import React, { Component } from 'react'
import { PropTypes } from 'prop-types'

class NumberSquare extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedNumber: 0
    }
  }

  clickEvent = (number) => {
    const { clickEvent } = this.props
    this.setState({ selectedNumber: number })
    clickEvent(number)
  }

  render() {
    const { number } = this.props

    const { selectedNumber } = this.state

    const items = []

    for (let i = 1; i <= number; i++) {
      const isActive = selectedNumber === i

      items.push(
        <button
          key={`num-${i}`}
          type="button"
          className={[
            'c-number-square-button',
            'c-number-square-size',
            isActive ? 'c-number-square-button--active' : null
          ].filter(Boolean).join(' ')}
          aria-pressed={isActive}
          onClick={() => this.clickEvent(i)}
        >
          <span className="c-number-square-text c-number-square-font">{i}</span>
        </button>
      )

      if (i % 4 === 0 && i !== number) {
        items.push(<div className="c-number-square-line-break" key={`break-${i}`} aria-hidden="true" />)
      }
    }

    return (
      <div className="c-number-square-container dsib-numberSquare">
        {items}
      </div>
    )
  }
}

export default NumberSquare

NumberSquare.propTypes = {
  number: PropTypes.number,
  clickEvent: PropTypes.func.isRequired,
}

NumberSquare.defaultProps = {
  number: 1
}
